import { render, staticRenderFns } from "./LotDamage.vue?vue&type=template&id=54fceb63"
import script from "./LotDamage.vue?vue&type=script&lang=js"
export * from "./LotDamage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports